/**
 * HoneypotField - Anti-spam hidden field component
 * 
 * This field is invisible to human users but gets filled by bots.
 * If filled, the backend will reject the submission.
 * 
 * Uses CSS positioning (not display:none) to avoid detection by sophisticated bots.
 */
import React from 'react';

export const HoneypotField = ({ value, onChange, name = "website" }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        opacity: 0,
        height: 0,
        width: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
      aria-hidden="true"
      tabIndex={-1}
    >
      <label htmlFor={`hp_${name}`}>
        Leave this field empty
      </label>
      <input
        type="text"
        id={`hp_${name}`}
        name={name}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
        tabIndex={-1}
      />
    </div>
  );
};

export default HoneypotField;
